import { useSnackbar } from "notistack";
import { useContext, useEffect, useRef } from "react";
import { LoginContext } from "../login/context/LoginContext";
import {
  GRAPHQL_WS_AUTH_REVOKED,
  GRAPHQL_WS_RECONNECTED,
  GRAPHQL_WS_TRANSPORT_ERROR,
} from "./realtimeEvents";

const GlobalRealtimeStatus = () => {
  const { token } = useContext(LoginContext);
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();
  const transportSnackbarRef = useRef(null);
  const hadTransportErrorRef = useRef(false);

  useEffect(() => {
    const onTransportError = (event) => {
      if (!token) return;
      if (event?.detail?.expectedClusterSwitch) return;
      hadTransportErrorRef.current = true;
      if (transportSnackbarRef.current) return;

      transportSnackbarRef.current = enqueueSnackbar(
        "即時連線中斷，正在重新連線；資料將於恢復後重新同步。",
        {
          key: "graphql-ws-transport-error",
          variant: "warning",
          persist: true,
        },
      );
    };

    const onReconnected = () => {
      if (!hadTransportErrorRef.current) return;

      if (transportSnackbarRef.current) {
        closeSnackbar(transportSnackbarRef.current);
        transportSnackbarRef.current = null;
      }
      enqueueSnackbar("即時連線已恢復，資料重新同步中。", {
        key: "graphql-ws-reconnected",
        variant: "success",
      });
      hadTransportErrorRef.current = false;
    };

    const onAuthRevoked = (event) => {
      if (!token) return;
      const code = Number(event?.detail?.code);
      if (code === 4401) {
        enqueueSnackbar("登入工作階段已失效，請重新登入。", {
          key: "graphql-ws-session-expired",
          variant: "error",
        });
      } else if (code === 4403) {
        enqueueSnackbar("即時連線授權已失效，資料已停止更新。", {
          key: "graphql-ws-permission-revoked",
          variant: "error",
        });
      }
    };

    window.addEventListener(GRAPHQL_WS_TRANSPORT_ERROR, onTransportError);
    window.addEventListener(GRAPHQL_WS_RECONNECTED, onReconnected);
    window.addEventListener(GRAPHQL_WS_AUTH_REVOKED, onAuthRevoked);

    return () => {
      window.removeEventListener(GRAPHQL_WS_TRANSPORT_ERROR, onTransportError);
      window.removeEventListener(GRAPHQL_WS_RECONNECTED, onReconnected);
      window.removeEventListener(GRAPHQL_WS_AUTH_REVOKED, onAuthRevoked);
      if (transportSnackbarRef.current) {
        closeSnackbar(transportSnackbarRef.current);
        transportSnackbarRef.current = null;
      }
    };
  }, [closeSnackbar, enqueueSnackbar, token]);

  return null;
};

export { GlobalRealtimeStatus };
